import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { CustomToast } from "./toast";
import gameApp from "@/index";

@customElement("room-access-screen")
export class RoomAccessScreen extends LitElement {
  @property() isOpen: boolean = false;

  @state()
  private enteredPassword: string = "";
  roomId: string;
  roomName: string;

  protected createRenderRoot() {
    return this;
  }

  handlePasswordInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.enteredPassword = input.value;
  }

  handleKeyPress(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.checkPassword();
    }
  }

  checkPassword() {
    gameApp.wsClient.sendMessage(
      JSON.stringify({
        action: "join_room",
        arguments: {
          roomId: this.roomId,
          password: this.enteredPassword,
        },
      })
    );
  }

  setRoom(id: string, name: string) {
    this.roomId = id;
    this.roomName = name;
  }

  showError() {
    const toast = document.querySelector("custom-toast") as CustomToast;
    toast?.openToast("Incorrect password. Please try again.", "top-right", 3000, "error");
  }

  hide() {
    this.isOpen = false;
  }

  open() {
    this.isOpen = true;
  }

  render() {
    if (!this.isOpen) return html``;

    return html`
      <div class="room-access-screen memberform">
        <h3>Enter Room: ${this.roomName}</h3>
        <p>This room is password-protected. Please enter the correct password to join.</p>
        <div class="login">
          <input
            type="password"
            placeholder="Enter password"
            class="input"
            @input="${this.handlePasswordInput}"
            @keypress="${this.handleKeyPress}"
          />
          <button class="btn" type="button" @click="${this.checkPassword}">
            Join Room
          </button>
        </div>
      </div>
    `;
  }
}